<template>
  <component-wrapper class="icon-text-fi">
    <grid-container-fi>
      <div
        class="fi-col-start-1 fi-col-end-13 md:fi-col-start-2 md:fi-col-end-12 lg:fi-col-start-3 lg:fi-col-end-11"
      >
        <!-- eslint-disable vue/no-v-html -->
        <headline-fi
          v-if="(isEditMode && fields.headline) || fields.headline?.value"
          tag="h2"
          class="icon-text-fi__headline"
          :size="30"
          :field="fields.headline"
        />
        <!-- eslint-enable vue/no-v-html -->
        <div class="icon-text-fi__elements">
          <icon-text-element-fi
            v-for="(iconTextElement, index) in fields.iconTextElements"
            :key="index"
            :icon="iconTextElement.fields?.icon"
            :headline="iconTextElement.fields?.headline"
            :text="iconTextElement.fields?.text"
          />
        </div>
        <div class="icon-text-fi__controls">
          <button-fi
            v-if="!isEditMode && fields.link?.value?.href"
            :href="fields.link.value?.href"
            :class="{
              'button-fi__primary fi-mt-48 sm:fi-mt-72 lg:fi-mt-96': true,
              'button-fi--large': isMD,
              'button-fi--medium': !isMD,
            }"
            natural-events
          >
            {{ fields.link.value.text }}
          </button-fi>

          <!-- eslint-disable vue/no-v-html -->
          <span
            v-if="isEditMode && fields.link"
            class="button-fi__primary button-fi--large fi-mt-96"
            v-html="fields.link.editable"
          />
          <!-- eslint-enable vue/no-v-html -->
        </div>
      </div>
    </grid-container-fi>
  </component-wrapper>
</template>

<script setup lang="ts">
import { ButtonFi, HeadlineFi } from 'atoms';

import ComponentWrapper from '@/components/component-wrapper/ComponentWrapper.vue';
import GridContainerFi from '@/components/grid-fi/GridContainerFi.vue';
import { useBreakpoints } from '@/composables/breakpoint';
import IconTextElementFi from '@/pages/icon-text-element-fi/IconTextElementFi.vue';
import type { LinkField, SingleLineTextField } from '@/sitecoreFieldTypes';

defineOptions({
  name: 'IconTextFi',
});

withDefaults(
  defineProps<{
    fields?: {
      link?: LinkField;
      headline?: SingleLineTextField;
      iconTextElements?: object[];
    };
  }>(),
  {
    fields: () => ({}),
  },
);

const { isMD } = useBreakpoints();
</script>

<style scoped src="./icon-text-fi" />
